import { FilterSubType, FilterType } from '../domain/filterTypes';
export interface SelectableOption {
  readonly id?: string;
  readonly value: string;
  readonly label: string;
  readonly type?: FilterType | FilterSubType;
}

export enum Connectors {
  And = 'AND',
  Or = 'OR',
  None = 'NONE'
}

enum Operators {
  DateEquals = 'DATE_EQUALS',
  Equals = 'EQUALS',
  NoteEquals = 'NOT_EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEquals = 'GREATER_THAN_OR_EQUALS',
  LessThan = 'LESS_THAN',
  LessThanOrEquals = 'LESS_THAN_OR_EQUALS',
  BetweenExclusive = 'BETWEEN_EXCLUSIVE',
  BetweenInclusive = 'BETWEEN_INCLUSIVE',
  IsAnyOf = 'IS_ANY_OF',
  IsNoneOf = 'IS_NONE_OF',
  IsBlank = 'IS_BLANK'
}

export const FilterConnectors = {
  and: Connectors.And,
  or: Connectors.Or,
  none: Connectors.None
} as const;

export const FilterOperators = {
  dateEquals: Operators.DateEquals,
  equals: Operators.Equals,
  noteEquals: Operators.NoteEquals,
  greaterThan: Operators.GreaterThan,
  greaterThanOrEquals: Operators.GreaterThanOrEquals,
  lessThan: Operators.LessThan,
  lessThanOrEquals: Operators.LessThanOrEquals,
  betweenExclusive: Operators.BetweenExclusive,
  betweenInclusive: Operators.BetweenInclusive,
  isAnyOf: Operators.IsAnyOf,
  isNoneOf: Operators.IsNoneOf,
  isBlank: Operators.IsBlank
} as const;

export type InputFilter = string | number | undefined | null;

export interface Ifilter {
  id?: string;
  field: string;
  operator: string;
  operands: InputFilter[];
  connector?: Connectors;
  validateInputs: boolean;
}

export interface OnChangeSignature {
  ({ value, name }: { value: string | InputFilter[]; name: string }): void;
}

export interface FilterOptions {
  fieldName: string;
  operators: SelectableOption[];
}

export enum FilterNames {
  AccountName = 'accounts',
  AccountType = 'accessType',
  BillingContact = 'billingContact',
  BillingCadence = 'billingCadence',
  SeatsPurchased = 'seatsPurchased',
  SeatsUsed = 'seatsUsed',
  SeatsAvailable = 'seatsAvailable',
  LastLoginDate = 'lastLoginDate',
  LastLaunchDate = 'lastLaunchDate',
  CreationDate = 'createdAt',
  TeamName = 'teams',
  AccountManager = 'managers',
  CustomerSuccessManager = 'customerSuccessManagers',
  ActiveUsers = 'activeUsers',
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  UserType = 'userType',
  // use for Features.PlgExternal3
  RenewalDate = 'renewalAt'
  // end of use for Features.PlgExternal3
}

export interface StringKey {
  [key: string]: string;
}
